// import type { ProgressUpdater } from "alova";
import type { RequestElements } from "alova";

function CustomFetchAdapter<T = any>(elements: RequestElements) {
  const { url, type, data, headers } = elements;
  const controller = new AbortController();

  const fetchPromise = fetch(url, {
    method: type,
    body:
      data instanceof FormData || data instanceof URLSearchParams
        ? data
        : data
        ? JSON.stringify(data)
        : undefined,
    headers: {
      ...headers,
      ...(data && !(data instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
    },
    signal: controller.signal,
  });

  return {
    async response(): Promise<T> {
      const response = await fetchPromise;
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const error = new Error(
          errorData?.message || `HTTP error! status: ${response.status}`
        );
        (error as any).status = response.status;
        (error as any).data = errorData; // simpan detail
        throw error;
      }
      return (await response.json()) as T;
    },
    async headers() {
      return (await fetchPromise).headers;
    },
    abort() {
      controller.abort();
    },
    // onDownload(handler: ProgressUpdater) {
    //   // implementasi progress jika perlu
    // },
    // onUpload(handler: ProgressUpdater) {
    //   // implementasi progress jika perlu
    // },
  };
}

export default CustomFetchAdapter;
